import React from 'react';

import LogoRimac from '../../../assets/LogoRIMAC.svg';
import LogoBBVA from '../../../assets/LogoBBVA.svg';
import IconPhone from '../../../assets/icons/ic_phone_blue.svg';
import * as constants from '../../../utils/constants';

const RimacTopBar = ({ phoneActive = false }) => {
  return (
    <div className="rimacTopBar" data-testid="error-pages">
      <div className={`rimacTopBar__wrapper ${phoneActive ? 'active' : ''}`}>
        <div className="rimacTopBar__logoCont">
          <a href={constants.LINK_RIMAC}>
            <img src={LogoRimac} alt="RIMAC" />
          </a>
          <div className="divider"></div>
          <a href={constants.LINK_BBVA}>
            <img src={LogoBBVA} alt="BBVA" />
          </a>
        </div>

        <div className={`rimacTopBar__infoCont ${phoneActive ? 'active' : ''}`}>
          <p>Si no recibiste tu póliza comunícate al</p>
          <span>
            <img src={IconPhone} alt="(01) 595-9000"></img>
          </span>
          <p className="blue">(01) 595-9000</p>
        </div>
      </div>
    </div>
  );
};

export default RimacTopBar;
